import {
  AngularFirestore,
  AngularFirestoreCollection,
  CollectionReference
} from "@angular/fire/firestore";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { Order, Timeframe } from "../models";
import * as firebase from "firebase";
export class OrderApi {
  public name: string;

  public collection: AngularFirestoreCollection<Order>;

  public venue_collection: AngularFirestoreCollection<Order>;
  public venue_reference: CollectionReference;
  constructor(
    collection: string,
    public db: AngularFirestore,
    public venueName: string
  ) {
    this.name = collection;
  }

  getAll(timeframe: Timeframe): Observable<Order[]> {
    this.collection = this.db.collection(this.name, ref =>
      ref
        .where(
          "summary.purchasedAt",
          ">=",
          firebase.firestore.Timestamp.fromDate(timeframe.begin)
        )
        .where(
          "summary.purchasedAt",
          "<=",
          firebase.firestore.Timestamp.fromDate(timeframe.end)
        )
        .orderBy("summary.purchasedAt", "desc")
    );
    return this.collection.snapshotChanges().pipe(
      map(actions => {
        return actions.map(action => {
          var data = action.payload.doc.data();
          var id = action.payload.doc.id;
          // data.id = action.payload.doc.id;
          // return data;
          return new Order(data, id);
        });
      })
    );
  }

  getVenueOrders(timeframe: Timeframe): Observable<Order[]> {
    this.venue_collection = this.db.collection("devOrders", ref =>
      ref
        .where("venue.name", "==", this.venueName)
        .where(
          "summary.purchasedAt",
          ">=",
          firebase.firestore.Timestamp.fromDate(timeframe.begin)
        )
        .where(
          "summary.purchasedAt",
          "<=",
          firebase.firestore.Timestamp.fromDate(timeframe.end)
        )
        .orderBy("summary.purchasedAt", "desc")
    );
    return this.venue_collection.snapshotChanges().pipe(
      map(actions => {
        return actions.map(action => {
          var data = action.payload.doc.data();
          var id = action.payload.doc.id;

          return new Order(data, id);
        });
      })
    );
  }

  //TODO: store all user orders under their user document
  async getNewUsers(timeframe: Timeframe): Promise<number> {
    const query = await this.db
      .collection<Order>("devUsers", ref =>
        ref
          .where(
            "created_at",
            ">=",
            firebase.firestore.Timestamp.fromDate(timeframe.begin)
          )
          .where(
            "created_at",
            "<=",
            firebase.firestore.Timestamp.fromDate(timeframe.end)
          )
          .orderBy("created_at", "desc")
      )
      .get()
      .toPromise();
    return query.docs.length;
  }
}
